import { Button } from '@mui/material';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';

import { ReactComponent as EmailIcon } from '../../../assets/icons/Login/emailIcon.svg';
import { ReactComponent as GoogleIcon } from '../../../assets/icons/Login/googleIcon.svg';
import { getPortalRuntimeConfig } from '../../../services/runtimeConfig';
import { useSignUpService } from '../../../services/signUpService';
import { getRedirectUriDetails } from '../../Login/redirect';
import styles from '../index.module.scss';

function SignUpFormButtons() {
  const { state } = useSignUpService();
  const { inviteKey } = useParams();
  const { cognito } = getPortalRuntimeConfig();
  const { redirectUri, state: redirectState } = getRedirectUriDetails({
    redirectUri: `${window.location.origin}/signup`,
    state: inviteKey,
  });
  const googleUrl = `${cognito.url}/oauth2/authorize?identity_provider=Google&redirect_uri=${redirectUri}&response_type=TOKEN&client_id=${cognito.clientId}&scope=openid+profile&prompt=select_account&state=${encodeURIComponent(redirectState)}`;
  return (
    <div
      className={classNames(
        'flex flex-col w-full items-center',
        styles.btContainer,
      )}
    >
      <Button
        variant="contained"
        className={styles.signUpBtn}
        onClick={() => {
          state.setSignUpMethod('email');
        }}
      >
        <EmailIcon />
        Sign up with Email
      </Button>
      <Button
        variant="contained"
        className={styles.signUpBtn}
        onClick={() => {
          window.location.replace(googleUrl);
        }}
        role="link"
      >
        <GoogleIcon />
        Sign up with Google
      </Button>
    </div>
  );
}
export default observer(SignUpFormButtons);
